import { TemplateRef, Type, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

export class SideMenuItem {
  constructor(
    public component: Type<any> | TemplateRef<any>,
    public label: string,
    public data: any,
    remove$: Observable<any>,
    public customInjector?: Injector
  ) {
    remove$.pipe(take(1)).subscribe(() => this._remove$.next());
  }
  private _remove$ = new Subject<void>();
  public get remove$() {
    return this._remove$.asObservable();
  }

  public id = Math.random().toString(36).substr(2, 10);
}
